var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is_edp_v2)?_c('EpisodeDetails'):_vm._e(),_vm._v(" "),(_vm.is_edp_v2)?_c('EpisodeDetailsV2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }